import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { listQueue } from "./thunks/list-queue";
import { resolveReport } from "./thunks/resolve-report";

const name = "reports";

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listQueue.pending, (state) => {
        state.isPending = true;
        state.isRejected = false;
        state.errorMessage = "";
      })
      .addCase(listQueue.fulfilled, (state, action) => {
        state.queue = action.payload;
        state.isPending = false;
        state.isRejected = false;
      })
      .addCase(listQueue.rejected, (state, action) => {
        state.isPending = false;
        state.isRejected = true;
        state.errorMessage = action.error.message ?? "";
      })
      .addCase(resolveReport.pending, (state) => {
        state.isResolving = true;
        state.resolveError = "";
      })
      .addCase(resolveReport.fulfilled, (state) => {
        state.isResolving = false;
      })
      .addCase(resolveReport.rejected, (state, action) => {
        state.isResolving = false;
        state.resolveError = action.error.message ?? "";
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
